import { render, staticRenderFns } from "./UserDetailContactsTab.vue?vue&type=template&id=61fc1eea&scoped=true&lang=pug&"
import script from "./UserDetailContactsTab.vue?vue&type=script&lang=js&"
export * from "./UserDetailContactsTab.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailContactsTab.vue?vue&type=style&index=0&id=61fc1eea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fc1eea",
  null
  
)

export default component.exports